export * from "./readings.component";
